import React from 'react';
import {Card, Button, Header, Form, Select, Accordion, Icon} from 'semantic-ui-react';
import {hasAccessPermission} from '../../../common/permissions/validations';
import {paths} from '../../../common/dictionaries/urls';
import {resources, scopes} from '../../../common/permissions/dictionary';
import {Actions} from '../../../common/actions';
import {connect} from 'react-redux';
import {isEmpty} from 'lodash';
import Search from '../tcc/Search';
import Loader from '../../../common/components/loader';
import Placeholder from '../../../common/components/placeholder';
import ShowInformationVehicle from '../tcc/ShowInformationVehicle';

import './styles.scss';
import {validateEmail} from '../../../common/util/fieldsValidation';
import NumberFormat from 'react-number-format';
import HeaderLogo from '../../common/HeaderLogo';
import TableRecord from './TableRecord';
import {validateDate} from '../../utils';

const ERROR_EMAIL = 'Email invalido';
const ERROR_FIELDS = 'Complete los campos requeridos';
const ERROR_DATE = 'No se puede actualizar un auto vendido pasado los 7 días';

class VehiclesCertificationSale extends React.Component {
  state = {
    'search': '',
    'name': '',
    'lastName': '',
    'phone': '',
    'email': '',
    'status': 'STOCK',
    'comment': '',
    'activeIndex': 0,
  }

  componentDidMount() {
    if (!hasAccessPermission(this.props.permissions, resources.VehiclesCertificationSale, scopes.See)) {
      this.props.push(paths.AccessDenied);
    }
    this.props.clearCertificationSale();
  }

  componentDidUpdate() {
    if (this.state.search === this.props.idRequest) {
      this.setState({
        'name': this.props.client.name || '',
        'lastName': this.props.client.lastName || '',
        'phone': this.props.client.phone || '',
        'email': this.props.client.email || '',
        'status': this.props.client.status || 'STOCK',
        'comment': this.props.client.comment || '',
      });
    }
  }


  handleInput = (e, data) => {
    const name = e.target.name;
    this.setState({
      [name]: data.value,
      'firstSearch': false,
    });
  };

  handleSearchChasis = (e) => {
    const {search} = this.state;
    this.props.getCertficationById(search);
  };

  clearState = (status) => {
    const modifyState = {};
    if (status === 'STOCK') {
      modifyState.name = '';
      modifyState.lastName = '';
      modifyState.phone = '';
      modifyState.email = '';
      modifyState.comment = '';
      modifyState.status = status;
    }
    return modifyState;
  }

  handleSelect = (e, name, value) => {
    this.setState({
      [name]: value,
      ...this.clearState(value),
    });
  };

  handleSave = () => {
    const {name, lastName, email, phone, comment, status} = this.state;
    const validateFields = name.length >= 3 && lastName.length >= 2 && email.length > 10 && phone.length >= 7;
    const {vehicle, client} = this.props;
    const date = client.dateUpdated || client.dateCreated;

    const data = {
      name, lastName, email, phone, 'comment': comment, status, 'idRequest': vehicle.vehCertId,
    };

    const vDate = validateDate(date);
    
    if (status === 'STOCK' && vDate) {
      const data = {...this.clearState('STOCK'), 'idRequest': vehicle.vehCertId};
      this.props.saveCertificationSale(data, vehicle.vehCertId);
    } else if (validateFields && vDate) {
      if (validateEmail(email)) {
        this.props.saveCertificationSale(data, vehicle.vehCertId);
      } else {
        this.props.addMessageBoxError(!vDate ? ERROR_DATE : ERROR_EMAIL);
      }
    } else {
      this.props.addMessageBoxError(!vDate ? ERROR_DATE : ERROR_FIELDS);
    }
  }

  handleAccordion = (e, index) => {
    const {activeIndex} = this.state;
    const newIndex = activeIndex === index ? -1 : index;
    this.setState({'activeIndex': newIndex});
  }


  render() {
    const {search, name, lastName, email, phone, comment, status, activeIndex} = this.state;
    const {vehicle, loading, records} = this.props;

    return (
      <div>
        <Card raised fluid>
          <div className="tcc-header">
            <HeaderLogo title={'Toyota certificados'}/>
            <div className="tcc-header-search-container">
              <Search text={'Número de solicitud'} search={search} type={true}
                handleSearchChasis={this.handleSearchChasis} handleInput={this.handleInput} />
              <div className="tcc-btns">
                {!isEmpty(vehicle) &&
                  <Button
                    disabled={vehicle.status !== 'APROBADO' && vehicle.status !== 'VENDIDO' }
                    color="green" onClick={this.handleSave}>
                          GUARDAR
                  </Button>
                }
              </div>
            </div>
          </div>
        </Card>

        { isEmpty(vehicle) ?
          <div >
            <Placeholder
              text={'Buscar  un certificado'}
              src={`${process.env.PUBLIC_URL}/icons/CarPlaceholder.svg`}
              alt="carro"
            />
          </div> :
          <div>
            { loading ? <Loader/> :
              <Card raised fluid>
                <Header className="tcc-sale-header" as='h2' textAlign='left'>Datos del Comprador
                  <span className='tcc-sale-budget' >
                  ESTADO: {vehicle.status}</span>
                </Header>
                <div className="tcc-wrapper">
                  <Form>
                    <Form.Group widths="equal">
                      <Form.Input
                        value={name}
                        name="name"
                        onChange={this.handleInput}
                        fluid
                        label="Nombre *"
                        placeholder="Nombre del Cliente"
                      />

                      
                      <Form.Input
                        value={lastName}
                        name="lastName"
                        onChange={this.handleInput}
                        fluid
                        label="Apellido *"
                        placeholder="Apellido del Cliente"
                      />

                      <Form.Field>
                        <label>Teléfono de contacto (min 7 dígitos) *</label>
                        <NumberFormat
                          min={7}
                          value={phone}
                          name="phone"
                          onChange={this.handleInput}
                          type="tel"
                          label="Teléfono de contacto *"
                          placeholder="Teléfono de contacto"
                        />
                      </Form.Field>
          
                    </Form.Group>
                    <Form.Group widths="three">
                      <Form.Input
                        type='email'
                        value={email}
                        name="email"
                        onChange={this.handleInput}
                        fluid
                        label="Email"
                        placeholder="Email del Cliente *"
                      />

                      <Form.Field
                        value={status}
                        name="status"
                        control={Select}
                        options={[{'key': 1, 'value': 'VENDIDO', 'text': 'VENDIDO'},
                          {'key': 2, 'value': 'STOCK', 'text': 'STOCK'}]}
                        onChange={(e, {value}) => this.handleSelect(e, 'status', value)}
                        label="Estado del vehículo"
                        placeholder="Estado del vehículo"
                      />
                    </Form.Group>

                    <Form.TextArea
                      value={comment}
                      name="comment"
                      onChange={this.handleInput}
                      label="Observación (opcional)"
                      placeholder="Observación del proceso"
                    />
                  </Form>
                </div>
                
                
                <Accordion style={{'textAlign': 'left'}}>
                  
                  <Accordion.Title
                    active={activeIndex === 1}
                    index={1}
                    onClick={(e) => this.handleAccordion(e, 1)}
                  >
                    <Icon name='dropdown' />
                    <span className="dropdown-title-sales">Historial del vehículo</span>
                  </Accordion.Title>
                  <Accordion.Content active={activeIndex === 1}>
                    <TableRecord records={records}/>
                  </Accordion.Content>

                  <Accordion.Title
                    active={activeIndex === 2}
                    index={2}
                    onClick={(e) => this.handleAccordion(e, 2)}
                  >
                    <Icon name='dropdown' />
                    <span className="dropdown-title-sales"> Información del vehículo</span>
                  </Accordion.Title>
                  <Accordion.Content active={activeIndex === 2}>
                    <ShowInformationVehicle vehicle={vehicle}></ShowInformationVehicle>
                  </Accordion.Content>
                </Accordion>
              </Card>
            }
          </div>
        }
      </div>
    );
  }
}

const {getCertficationById, saveCertificationSale, addMessageBoxError, clearCertificationSale,
  getVehicleSaleRecord, withRouter} = Actions;

const mapStateToProps = (state, ownProps) => {
  return {
    'permissions': state.session.permissions,
    'push': ownProps.history.push,
    'vehicle': state.tccSale.tccSaleVehicle,
    'records': state.tccSale.recordSale,
    'loading': state.tccSale.loading,
    'client': state.tccSale.tccSale,
  };
};

export default withRouter(connect(mapStateToProps,
  {getCertficationById,
    saveCertificationSale,
    clearCertificationSale,
    getVehicleSaleRecord,
    addMessageBoxError}
)(VehiclesCertificationSale));
